import React from 'react';
import './artwork.scss';

export default class Artwork extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      artwork: props.artwork || {},
      showDetails: props.showDetails || false,
      showImage: props.showImage || false,
      show: false,
      hasFocus: props.hasFocus|| true,
    }

    this.getArtworkUrl = this.getArtworkUrl.bind(this);
  }

  componentWillReceiveProps({ showDetails, artwork, showImage, hasFocus }) {
    this.setState({ showDetails, artwork, showImage, hasFocus });
  }

  getArtworkUrl(artwork) {
    const { showImage } = this.props;
    if (!showImage) return '';

    if (artwork && artwork.media && artwork.media.image && artwork.media.image.low && artwork.media.image.low.landscape) {
      return artwork.media.image.low.landscape;
    }
    return '';
  }

  render() {
    const { artwork } = this.state;
    return (
      <div className={this.state.showDetails ? "artwork artwork--details" : "artwork"}>
        <div className="artwork__imagecontainer">
          {this.state.showImage ? <img className={this.state.show ? this.state.showDetails ? "image" : "imageRadius" : "none"} src={this.getArtworkUrl(artwork)} onLoad={() => { this.state.show ? null : this.setState({ show: true }) }} /> : null}
        </div>
        {
          this.state.showDetails ?
            <div className="artwork__details">
              <div className="artwork__details__container">
                <h6 className="h--spacing-sm">{artwork.name}</h6>
                <h6 className="h--no-spacing h--normalize-weight">{artwork._embedded ? `${artwork._embedded.artist.givenName} ${artwork._embedded.artist.surname}` : ''}</h6>
              </div>
              <div className="artwork__details__play">
                <span class="artwork__details__dot"></span>
                <span class={this.state.hasFocus || this.props.focus ? "ion-play focused" : "ion-play"}></span>
              </div>
            </div> :
            null
        }
      </div>
    )
  }
};
